__turbopack_context__.v({
  "content": "Selector-module-scss-module__t9Yzfq__content",
  "dropdownMenu": "Selector-module-scss-module__t9Yzfq__dropdownMenu",
  "item": "Selector-module-scss-module__t9Yzfq__item",
  "loadingSkeleton": "Selector-module-scss-module__t9Yzfq__loadingSkeleton",
  "selector-skeleton-loading": "Selector-module-scss-module__t9Yzfq__selector-skeleton-loading",
  "separator": "Selector-module-scss-module__t9Yzfq__separator",
  "wrapper": "Selector-module-scss-module__t9Yzfq__wrapper",
});
